export default __webpack_public_path__ + "static/media/downLeftArrowHover.2f60e302.png";